const func = ($target) => {

    var $inlineVideoPlay = $target.find('.inlineVideoPlay'),
        $iframe = $target.find('iframe'),
        src = $iframe.attr('src'),
        overlay = $target.find('.overlay-bg'),
        $playVideo = $target.find('.playVideo'),
        $videoModal = $target.find('.modal'),
        $modalSrc = $videoModal.find('iframe').attr('src'),
        $body = $('body');

    $inlineVideoPlay.on('click', function () {
        var $iframe = $(this).parent().parent().find('iframe'),
            src = $iframe.attr('src');
        overlay.addClass('d-none')
        $playVideo.addClass('d-none')
        if ($iframe.length > 0) {
            src = src.replace('controls=0', 'controls=1');
            $iframe.attr('src', src + '&autoplay=1');
        } else {
            $(this).parent().parent().find('video').trigger('play').attr('controls', true);
        }
    })

    $videoModal
        .on('show.bs.modal', function (e) {
            var $iframe = $(this).find('iframe'),
                $video = $(this).find('video');

            $body.addClass('modal-backdrop-media');
            if ($iframe.length > 0) {
                if (src.indexOf('?') == -1) {
                    $iframe.attr('src', $modalSrc + '?autoplay=1');
                } else {
                    $iframe.attr('src', $modalSrc + '&autoplay=1');
                }
            } else {
                $video.trigger('play');
            }
        })
        .on('hidden.bs.modal', function (e) {
            var $iframe = $(this).find('iframe'),
                $video = $(this).find('video');
            $body.removeClass('modal-backdrop-media');
            if ($iframe.length > 0) {
                $iframe.attr('src', '');
            } else {
                $video.trigger('pause');
            }
        });
}

export default func;
